import { render, staticRenderFns } from "./report-file.vue?vue&type=template&id=e974d3f0"
import script from "./report-file.vue?vue&type=script&lang=ts"
export * from "./report-file.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports